F
<template>
    <AppLayout
        page="/dashboard"
        pageTitle="Finance Entry"
        backLink="/dashboard/reports"
        @fabAction="newFinanceEntry = true"
    >
        <v-col cols="12" class="pa-1">
            <v-card class="soli-round">
                <v-container class="px-3" fluid>
                    <v-list>
                        <v-list-item>
                            <v-list-item-content>
                                <v-list-item-title class="soli-subtitle"
                                    >{{
                                        `${$page.props.auth.user.selected_location.name}`
                                    }}
                                </v-list-item-title>
                                <v-list-item-subtitle
                                    style="white-space: normal"
                                    >{{
                                        `Monthly finance tracking from Quickbooks`
                                    }}
                                </v-list-item-subtitle>
                                <v-list-item-subtitle
                                    class="font-bold"
                                    style="white-space: normal"
                                >
                                </v-list-item-subtitle>
                            </v-list-item-content> </v-list-item
                    ></v-list>
                    <v-data-table
                        :headers="headers"
                        :items="studioFinances"
                        hide-default-footer
                        disable-pagination
                        mobile-breakpoint="0"
                        @click:row="editEntry($event)"
                        style="cursor: pointer"
                    >
                        <template v-slot:[`item.date`]="{ item }">
                            <div class="d-flex align-center py-2">
                                {{ globalMomentMonthYear(item.date) }}
                            </div>
                        </template>
                        <template v-slot:[`item.revenue`]="{ item }">
                            <div class="d-flex align-center py-2">
                                {{ formatter(item.revenue) }}
                            </div>
                        </template>
                        <template v-slot:[`item.cost_of_goods`]="{ item }">
                            <div class="d-flex align-center py-2">
                                {{ formatter(item.cost_of_goods) }}
                            </div>
                        </template>
                        <template v-slot:[`item.expenses`]="{ item }">
                            <div class="d-flex align-center py-2">
                                {{ formatter(item.expenses) }}
                            </div>
                        </template>
                        <template v-slot:[`item.marketing`]="{ item }">
                            <div class="d-flex align-center py-2">
                                {{ formatter(item.marketing) }}
                            </div>
                        </template>
                        <template v-slot:[`item.liabilities`]="{ item }">
                            <div class="d-flex align-center py-2">
                                {{ formatter(item.liabilities) }}
                            </div>
                        </template>
                    </v-data-table>
                </v-container>
            </v-card>
        </v-col>

        <SoliForm
            v-if="newFinanceEntry"
            :title="`${editing ? 'Editing' : 'New'} Finance Entry`"
            icon="save"
            ref="form"
            persistent
            :loadingProp="form.processing"
            @submit="submitFinances()"
            @reset="resetFinances()"
        >
            <template #body>
                <SoliDate
                    type="month"
                    v-model="form.date"
                    :rules="rules.input"
                    :error="errors.date"
                    :max="dateMax()"
                    :events="
                        studioFinances.length
                            ? studioFinances.map((e) =>
                                  globalMomentMonthYear(e.date)
                              )
                            : globalMomentMonthYear(new Date())
                    "
                ></SoliDate>
                <v-currency-field
                    label="Revenue"
                    v-model="form.revenue"
                    :rules="rules.input"
                    outlined
                    dense
                    class="soli-round"
                    :error-messages="errors.revenue"
                ></v-currency-field>
                <v-currency-field
                    label="Cost of Goods"
                    v-model="form.cost_of_goods"
                    :rules="rules.input"
                    outlined
                    dense
                    class="soli-round"
                    :error-messages="errors.cost_of_goods"
                ></v-currency-field>
                <v-currency-field
                    label="Expenses"
                    v-model="form.expenses"
                    :rules="rules.input"
                    outlined
                    dense
                    class="soli-round"
                    :error-messages="errors.expenses"
                ></v-currency-field>
                <v-currency-field
                    label="Marketing"
                    v-model="form.marketing"
                    :rules="rules.input"
                    outlined
                    dense
                    class="soli-round"
                    :error-messages="errors.marketing"
                ></v-currency-field>
                <v-currency-field
                    label="Liabilities"
                    v-model="form.liabilities"
                    :rules="rules.input"
                    outlined
                    dense
                    class="soli-round"
                    :error-messages="errors.liabilities"
                ></v-currency-field>
            </template>
        </SoliForm>

        <SoliSnack
            v-if="showMessage"
            @hide="showMessage = false"
            :text="$page.props.successMessage"
        ></SoliSnack>
    </AppLayout>
</template>

<script>
import AppLayout from "./../../Layouts/AppLayout";
import { Link } from "@inertiajs/vue2";
import SoliForm from "./../../Components/Base/SoliForm";
import globalMoment from "../../Mixins/GlobalMoment";

export default {
    props: ["studioFinances", "errors"],
    mixins: [globalMoment],
    components: {
        AppLayout,
        Link,
        SoliForm,
    },
    data() {
        return {
            showMessage: false,
            newFinanceEntry: null,
            loading: false,
            editing: false,
            rules: SoliForm.formRules,
            form: this.$inertia.form({
                id: null,
                date: null,
                revenue: null,
                cost_of_goods: null,
                expenses: null,
                marketing: null,
                liabilities: null,
            }),
            headers: [
                {
                    text: "Date",
                    align: "start",
                    sortable: true,
                    value: "date",
                },
                /*{
                    text: "Location",
                    align: "start",
                    sortable: true,
                    value: "Location",
                },*/
                {
                    text: "Revenue",
                    align: "start",
                    sortable: true,
                    value: "revenue",
                },
                {
                    text: "Cost of Goods",
                    align: "start",
                    sortable: true,
                    value: "cost_of_goods",
                },
                {
                    text: "Expenses",
                    align: "start",
                    sortable: true,
                    value: "expenses",
                },
                {
                    text: "Marketing",
                    align: "start",
                    sortable: true,
                    value: "marketing",
                },
                {
                    text: "Liabilities",
                    align: "start",
                    sortable: true,
                    value: "liabilities",
                },
            ],
        };
    },
    methods: {
        formatter(val) {
            return new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            }).format(val);
        },
        editEntry(entry) {
            this.form.id = entry.id;
            this.form.date = entry.date;
            this.form.revenue = entry.revenue;
            this.form.cost_of_goods = entry.cost_of_goods;
            this.form.expenses = entry.expenses;
            this.form.marketing = entry.marketing;
            this.form.liabilities = entry.liabilities;

            this.editing = true;
            this.newFinanceEntry = true;
        },
        submitFinances() {
            if (!this.$refs.form.$refs.form.validate()) return;

            let options = {
                preserveState: true,
                preserveScroll: true,
                onSuccess: () => {
                    this.showMessage = true;
                    this.resetFinances();
                },
                onError: () => {
                    console.log(
                        "Form returned errors: " + JSON.stringify(this.errors)
                    );
                },
            };

            if (this.editing) {
                this.form.put(
                    `/dashboard/reports/finance-entry/${this.form.id}`,
                    options
                );
            } else {
                this.form.post("/dashboard/reports/finance-entry", options);
            }
        },
        resetFinances() {
            this.$refs.form.reset();

            setTimeout(() => {
                this.form.reset();
                this.editing = false;
                this.newFinanceEntry = null;
                // Object.keys(this.form).forEach((e) => (this.form[e] = null));
            }, 300);
        },
        dateMax() {
            return moment()
                .subtract(1, "month")
                .startOf("month")
                .format("YYYY-MM-DD");
        },
    },
    computed: {},
};
</script>
